import { JOIN_PRO_INFO_ROUTE_PER_PRO_PER_TYPE } from '@application/constants';
import type { UseRouterReturn } from '@application/utils';

export const joinProLinks = (
  translate: UseRouterReturn['translate'],
  navigateToRoute: UseRouterReturn['navigateToRoute'],
  routeLocationDescriptor: UseRouterReturn['routeLocationDescriptor'],
) => [
  {
    label: translate('header.proSolutions.VET'),
    onClick: () => navigateToRoute('joinVet'),
    link: routeLocationDescriptor('joinVet'),
    links: [
      {
        label: translate('header.proSolutions.profile'),
        onClick: () => navigateToRoute(JOIN_PRO_INFO_ROUTE_PER_PRO_PER_TYPE.VET.PROFILE),
        link: routeLocationDescriptor(JOIN_PRO_INFO_ROUTE_PER_PRO_PER_TYPE.VET.PROFILE),
      },
      {
        label: translate('header.proSolutions.seo'),
        onClick: () => navigateToRoute(JOIN_PRO_INFO_ROUTE_PER_PRO_PER_TYPE.VET.SEO),
        link: routeLocationDescriptor(JOIN_PRO_INFO_ROUTE_PER_PRO_PER_TYPE.VET.SEO),
      },
      {
        label: translate('header.proSolutions.agenda'),
        onClick: () => navigateToRoute(JOIN_PRO_INFO_ROUTE_PER_PRO_PER_TYPE.VET.AGENDA),
        link: routeLocationDescriptor(JOIN_PRO_INFO_ROUTE_PER_PRO_PER_TYPE.VET.AGENDA),
      },
      {
        label: translate('header.proSolutions.booking'),
        onClick: () => navigateToRoute(JOIN_PRO_INFO_ROUTE_PER_PRO_PER_TYPE.VET.BOOKING),
        link: routeLocationDescriptor(JOIN_PRO_INFO_ROUTE_PER_PRO_PER_TYPE.VET.BOOKING),
      },
    ],
  },
  {
    label: translate('header.proSolutions.GROOMER'),
    onClick: () => navigateToRoute('joinGroomer'),
    link: routeLocationDescriptor('joinGroomer'),
    links: [
      {
        label: translate('header.proSolutions.profile'),
        onClick: () => navigateToRoute(JOIN_PRO_INFO_ROUTE_PER_PRO_PER_TYPE.GROOMER.PROFILE),
        link: routeLocationDescriptor(JOIN_PRO_INFO_ROUTE_PER_PRO_PER_TYPE.GROOMER.PROFILE),
      },
      {
        label: translate('header.proSolutions.seo'),
        onClick: () => navigateToRoute(JOIN_PRO_INFO_ROUTE_PER_PRO_PER_TYPE.GROOMER.SEO),
        link: routeLocationDescriptor(JOIN_PRO_INFO_ROUTE_PER_PRO_PER_TYPE.GROOMER.SEO),
      },
      {
        label: translate('header.proSolutions.agenda'),
        onClick: () => navigateToRoute(JOIN_PRO_INFO_ROUTE_PER_PRO_PER_TYPE.GROOMER.AGENDA),
        link: routeLocationDescriptor(JOIN_PRO_INFO_ROUTE_PER_PRO_PER_TYPE.GROOMER.AGENDA),
      },
      {
        label: translate('header.proSolutions.booking'),
        onClick: () => navigateToRoute(JOIN_PRO_INFO_ROUTE_PER_PRO_PER_TYPE.GROOMER.BOOKING),
        link: routeLocationDescriptor(JOIN_PRO_INFO_ROUTE_PER_PRO_PER_TYPE.GROOMER.BOOKING),
      },
    ],
  },
  {
    label: translate('header.proSolutions.EDUCATOR'),
    onClick: () => navigateToRoute('joinEducator'),
    link: routeLocationDescriptor('joinEducator'),
  },
];
